import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

import { SearchInput } from 'components';
import { 
  Typography, 
  Button,
  TextField,
  MenuItem
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  rowIcons: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    //paddingLeft: theme.spacing(8),
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  // row1: {
  //   width: '240px',
  //   display: 'flex',
  //   alignItems: 'center',
  //   marginLeft: theme.spacing(6),
  //   '& > *': {
  //     marginLeft: theme.spacing(0),
  //     margin: theme.spacing(1),
  //   },
  // },
  spacer: {
    flexGrow: 1
  },
  Button: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
}));

const DistributorToolbar = props => {
  //const { className, ...rest } = props;

  const { 
    className, 
    onClickSearch,
    contracts,
    valueContract,
    onChangeContract, 
    ...rest
  } = props;

  const classes = useStyles();

  const [distributorName, setDistributorName] = useState('');

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>
        <Typography
          className={classes.registerListItemTitle}
          color="textSecondary"
          gutterBottom
        >
          대리점명
        </Typography>

        <SearchInput
          className={classes.searchInput}
          placeholder=""
          value={distributorName}
          onChange={e => setDistributorName(e.target.value)}
        />

        <Button
          color="primary"
          variant="contained"
          onClick={ () => onClickSearch(distributorName) }
        >
          조회
        </Button>
       
      </div>

      <div className={classes.row}>
        <TextField
          className={classes.registerListItemInput}
          id="outlined-select-agency"
          required 
          select
          label="계약 상태"
          value={valueContract}
          onChange={onChangeContract}
          helperText=""
          //variant="outlined"
          margin="dense"
        >
          {contracts.map(contract => (
            <MenuItem key={contract.value} value={contract.value}>
              {contract.label}
            </MenuItem>
          ))}
        </TextField>
      </div>
     
    </div>
  );
};

DistributorToolbar.propTypes = {
  className: PropTypes.string
};

export default DistributorToolbar;
